import axios from 'axios';
import c from '../helpers/constants';
import { objectToQueryString } from '../helpers/functions';

export function getProduct(customerId: string, sku: string ) {
  const obj = {
    customerid: customerId,
    searchsku: sku,
  };
  const queryString = objectToQueryString(obj);
  return (
    axios({
      url: `${c.API_ENDPOINTS.PRODUCT_DETAILS}?${queryString}`,
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
    })
      .then((response: any) => {
        return response?.data;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}

export function getProducts(customerId: string, productTypeCode?: string, searchSelection?: string, searchQuality?: string, searchColor?: string ) {
  const obj = {
    customerid: customerId,
    producttypecode: productTypeCode,
    searchquality: searchQuality,
    searchcolor: searchColor,
    searchselection: searchSelection,
  };
  const queryString = objectToQueryString(obj);
  return (
    axios({
      url: `${c.API_ENDPOINTS.PRODUCT_DETAILS}?${queryString}`,
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
    })
      .then((response: any) => {
        return response?.data;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}
